// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressRow_container__DM-ya","addressWrapper":"AddressRow_addressWrapper__155G6","img":"AddressRow_img__1t35_","deleteWrapper":"AddressRow_deleteWrapper__3JuZL"};